module.exports = __tmimport("~endpoint:{controller: \'customized/checkout\', action: \'index\'}");